import React, { useEffect, useState } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import FormRating from '../ReactHookFormCustom/FormRating';
import FormInput from '../ReactHookFormCustom/FormInput';
import FormTextArea from '../ReactHookFormCustom/FormTextArea';

const CommentsModal = ({ showModal, comment, editComment, onHandleValidSubmit, onToggle }) => {
  const { t } = useTranslation();
  const { handleSubmit, reset, control } = useForm({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    reset({
      commentId: comment?.id,
      commentRating: comment?.rating, // it seems that on the Rating this system does not work. You have to use initialValue on <FormRating :/
      commentTitle: comment?.title,
      messageTextArea: comment?.message,
    });
  }, [comment]);

  const handleSubmitWithValidations = (values) => {
    setIsLoading(true);
    onHandleValidSubmit(values);
  };

  return (
    <div>
      <Modal isOpen={showModal} size="lg" centered>
        <form onSubmit={handleSubmit(handleSubmitWithValidations)}>
          <ModalHeader className="d-block w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <em className="fa-2x icon-bubble" />
                <span className="ml-2">{t('common.COMMENT')}</span>
              </div>
              <div style={{ minWidth: '150px', textAlign: 'right' }}>
                <FormRating
                  control={control}
                  initialValue={comment?.rating}
                  name="commentRating"
                  id="commentRatingId"
                  size={30}
                  readonly={!editComment}
                  transition
                />
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormInput control={control} name="commentId" hidden disabled />
                <FormInput
                  control={control}
                  name="commentTitle"
                  id="commentTitleId"
                  label={t('common.TITLE')}
                  disabled={!editComment}
                  rules={{ required: t('common.REQUIRED') }}
                />
              </Col>
            </Row>
            <Row className="pt-2">
              <Col>
                <FormTextArea
                  disabled={!editComment}
                  control={control}
                  name="messageTextArea"
                  id="messageTextAreaId"
                  label={t('common.MESSAGE')}
                  maxLength={3000}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            {editComment && (
              <div>
                <Button color="primary" disabled={isLoading}>
                  {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
                  {t('common.SAVE')}
                </Button>
                <Button color="secondary" className="ml-2" onClick={onToggle}>
                  {t('common.CANCEL')}
                </Button>
              </div>
            )}
            {!editComment && (
              <Button color="primary" onClick={onToggle}>
                {t('common.OK')}
              </Button>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default CommentsModal;
